import VSelectCourseWhitelist from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCourseWhitelist', VSelectCourseWhitelist),
};
